const context = require.context('./', true, /\.\/[^/]+\/index\.js$/)

context.keys().forEach((filePath) => {
  // Remove the './' an(filePath)h)h)' from the object key
  const componentName = filePath.replace(/^.+\/([^/]+)\/index\.js/, '$1')
  if (process.env.NODE_ENV === 'development') console.log('%cExporting slice: ', 'color:green', componentName)
  module.exports[componentName] = context(filePath).default
})
